import { LabelProps } from "recharts";
import { EColor } from "../../../constants/colors";
import { RANKING_MAX } from "../utils/normalizeData";
import { invertRanking } from "../utils/invertRanking";
import { isOnlyThisEnabled } from "../utils/isOnlyThisEnabled";
import { ChartSeriesKey, VisibleSeries } from "../types";

export const createBarLabelRenderer = (visibleSeries: VisibleSeries) => {
  return (props: LabelProps) => {
    const { x, y, width, value } = props;

    if (x == null || y == null || width == null || value == null) {
      return null;
    }

    return (
      <g>
        {isOnlyThisEnabled(visibleSeries, ChartSeriesKey.Ranking) && (
          <text
            x={Number(x) + Number(width) / 2}
            y={Number(y) - 12}
            textAnchor="middle"
            fill={EColor.Gray}
            fontSize={22}
          >
            {invertRanking(Number(value), RANKING_MAX).toFixed(1)}
          </text>
        )}
        <rect
          id="shadow-rect"
          x={Number(x) - ((Number(width) * 1.41) - Number(width)) / 2}
          y={Number(y)}
          width={Number(width) * 1.41}
          height={10}
          rx={6}
          ry={6}
          fill={EColor.Yellow}
        />
      </g>
    );
  };
};